export default {
    computedCustomers () {
        return this.customers.map(customer => {
            return {
                ...customer[0],
                countTrip: customer.totalTrips
            }
        })
    }
}